/** "New on Pal Stars" crawl path: links fresh pages from trusted hub pages. */
export type NewPage = { href: string; title: string; blurb: string };

export const NEW_GAMEPLAY_PAGES: NewPage[] = [
  { href: "/guides/palworld-mobile-strategy-hub", title: "Palworld Mobile Strategy Hub", blurb: "Everything we know about playing Palworld on your phone." },
  { href: "/guides/palworld-mobile-garena", title: "Palworld Mobile (Garena)", blurb: "The Garena version, its Korea beta and what changes on mobile." },
  { href: "/guides/palworld-mobile-krafton", title: "Palworld Mobile (Krafton)", blurb: "Krafton's take on Palworld for mobile, explained." },
  { href: "/blog/palworld-news-fall-2026-roundup", title: "Palworld News: Fall 2026", blurb: "The latest updates, events and patches in one place." },
  { href: "/blog/palworld-mobile-garena-korea-beta-gameplay", title: "Garena Korea Beta Gameplay", blurb: "Hands-on notes from the mobile beta." },
];

export const NEW_MARKET_PAGES: NewPage[] = [
  { href: "/booster-pack/legends-awaken", title: "Legends Awaken (EBP02) Booster", blurb: "Release window, pack breakdown and pull-rate expectations." },
  { href: "/prices/legends-awaken", title: "Legends Awaken Prices", blurb: "Launch-week price tracking and the predicted checklist." },
  { href: "/blog/palworld-tcg-market-status-fall-2026", title: "TCG Market Status: Fall 2026", blurb: "Where Palworld card prices stand right now." },
];

export function NewPagesLinks({ pages, heading = "New on Pal Stars" }: { pages: NewPage[]; heading?: string }) {
  return (
    <section className="mt-10" aria-labelledby="new-pages-heading">
      <h2 id="new-pages-heading" className="text-xl font-bold">{heading}</h2>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {pages.map((p) => (
          <li key={p.href}>
            <a href={p.href} className="glass rounded-xl p-4 card-hover block">
              <span className="font-semibold text-primary">{p.title}</span>
              <span className="mt-1 block text-sm text-muted-foreground">{p.blurb}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
